import {lazy} from 'react';

const profileRoutes = [
    {
        exact: true,
        path: '/Profile',
        component: lazy(() => import('../views/Profile'))
    },
    {
        exact: true,
        path: '/EditBankDetails',
        component: lazy(() => import('../views/Profile/Profile/EditBankDetail'))
    },
    {
        exact: true,
        path: '/Help',
        component: lazy(() => import('../views/Profile/Profile/Help'))
    },
    {
        exact: true,
        path: '/referrals',
        component: lazy(() => import('../views/Profile/Profile/Referral'))
    },
    {
        exact: true,
        path: '/manageUsers',
        component: lazy(() => import('../views/Profile/Profile/ManageUser'))
    },
    {
        exact: true,
        path: '/manageBilling',
        component: lazy(() => import('../views/Profile/Profile/ManageBilling'))
    },
    {
        exact: true,
        path: '/addReferral',
        component: lazy(() => import('../views/Profile/Profile/AddReferral'))
    },
    {
        exact: true,
        path: '/AccountSetting',
        component: lazy(() => import('../views/Profile/Profile/AccountSetting'))
    },
    {
        exact: true,
        path: '/ChangePassword',
        component: lazy(() => import('../views/Profile/Profile/ChangePassword'))
    },
    {
        exact: true,
        path: '/ForgotPassword',
        component: lazy(() => import('../views/Profile/Profile/ForgotPassword'))
    },
    {
        exact: true,
        path: '/ForgotPassOTP',
        component: lazy(() => import('../views/Profile/Profile/ForgotPassOTP'))
    },
    {
        exact: true,
        path: '/Complaint',
        component: lazy(() => import('../views/Profile/Profile/RaiseComplaint'))
    },
    {
        exact: true,
        path: '/TicketDetails',
        component: lazy(() => import('../views/Profile/Profile/TicketDetails'))
    },
    {
        exact: true,
        path: '/addSubCustomer',
        component: lazy(() => import('../views/Profile/Profile/add_sub_customer/index'))
    },
    {
        exact: true,
        path: '/assignedAssets',
        component: lazy(() => import('../views/Profile/Profile/assignedAssets/AssignedAsset'))
    },
    {
        exact: true,
        path: '/linkedAssets',
        component: lazy(() => import('../views/Profile/Profile/add_billing/LinkedAssets.js'))
    },
    {
        exact: true,
        path: '/unAssignedAssets',
        component: lazy(() => import('../views/Profile/Profile/assignedAssets/AssignedAsset'))
    },
    {
        exact: true,
        path: '/addAssetsToCustomer',
        component: lazy(() => import('../views/Profile/Profile/assignedAssets/AssignedAsset'))
    },
    {
        exact: true,
        path: '/fleetVan',
        component: lazy(() => import('../views/Profile/Profile/BPCLMarketingPage.js'))
    },
    {
        exact: true,
        path: '/history/:van',
        component: lazy(() => import('../views/Profile/Profile/HistoryFleetVAN.js'))
    },
    {
        exact: true,
        path: '/addBilling',
        component: lazy(() => import('../views/Profile/Profile/add_billing/index'))
    }
];

export default profileRoutes;
